export const AUTH_PREFIX_KEY = "inspecionar:authentication";
export const AUTH_TOKEN = `${AUTH_PREFIX_KEY}:auth`;
export const AUTH_USER = `${AUTH_PREFIX_KEY}:user`;
export const AUTH_TEMP_USER = `${AUTH_PREFIX_KEY}:userTemp`;
